import { render, staticRenderFns } from "./ContainerCards.vue?vue&type=template&id=181b1c37"
import script from "./ContainerCards.vue?vue&type=script&lang=js"
export * from "./ContainerCards.vue?vue&type=script&lang=js"
import style0 from "./ContainerCards.vue?vue&type=style&index=0&id=181b1c37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports